/**
 * Раскладка карточки уведомления, общая у живой карточки (`notification.tsx`) и скелетона
 * (`notification-skeleton.tsx`): правится в одном месте, и плашка не расходится с карточкой.
 * Размер и форма плитки типа — `UD_ICON_TILE_METRICS` кита.
 */

/** Корень карточки: плитка слева, тело справа. */
export const NOTIFICATION_CARD_LAYOUT = 'flex items-start gap-4';

/** Тело: шапка и подложка текста с одним шагом между ними. */
export const NOTIFICATION_BODY_LAYOUT = 'flex min-w-0 grow flex-col gap-3';

/** Шапка: заголовок, бейджи, дата и действия; переносится на узком экране. */
export const NOTIFICATION_HEADER_LAYOUT = 'flex min-h-8 flex-wrap items-center gap-x-3 gap-y-1';

/** Утопленная подложка текста уведомления. */
export const NOTIFICATION_TEXT_BLOCK = 'bg-surfaceSunken rounded-card px-3 py-2.5';
